export const environment = {
  defaultDomain: window.location.host,
  production: true,
  endpoint: '/api',
  defaultLanguage: 'en_GB',
  wsEndpoint: (window.location.protocol === 'https:') ? `wss://${window.location.host}/ws` : `ws://${window.location.host}/ws`,
  sentryDSN: 'https://0edce7adad444a4797aae9287bbb11dc@o242141.ingest.us.sentry.io/1763422',
  payments: {
    url: 'https://payments.secure.avantio.pro/v1'
  }
};
